import { render, staticRenderFns } from "./OmsButton.vue?vue&type=template&id=66bdf72f&scoped=true"
import script from "./OmsButton.vue?vue&type=script&lang=js"
export * from "./OmsButton.vue?vue&type=script&lang=js"
import style0 from "./OmsButton.vue?vue&type=style&index=0&id=66bdf72f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bdf72f",
  null
  
)

export default component.exports